import React from 'react';
import { STEPS } from '../mock';
import FadeInSection from './FadeInSection';
import SafeMotion from './SafeMotion';

export default function Steps() {
  return (
    <section id="system" className="relative py-20 md:py-32">
      <div className="absolute inset-x-0 top-0 h-[400px] radial-glow-soft opacity-70 pointer-events-none" />
      <div className="relative max-w-6xl mx-auto px-6">
        <FadeInSection className="text-center max-w-3xl mx-auto">
          <h2 className="font-display text-white text-3xl sm:text-4xl md:text-6xl leading-[1.05] tracking-tight">
            Get started in <span className="text-orange-gradient">3 simple steps</span>
          </h2>
          <p className="mt-5 text-[#f2f2f2] text-[14px] md:text-base uppercase tracking-wide">
            A performance based system with no gimmicks. Register, trade Silver, collect cash weekly.
          </p>
        </FadeInSection>

        <div className="mt-10 md:mt-14 grid grid-cols-1 md:grid-cols-3 gap-5">
          {STEPS.map((s, i) => (
            <SafeMotion
              key={s.n}
              initial={{ filter: 'blur(10px)', opacity: 0, y: 30 }}
              whileInView={{ filter: 'blur(0px)', opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.1, margin: '0px 0px -80px 0px' }}
              transition={{ duration: 0.7, ease: 'easeOut', delay: i * 0.12 }}
              className="card-dark p-6 md:p-8"
            >
              <div className="font-display text-5xl md:text-7xl text-orange-gradient leading-none">{s.n}</div>
              <div className="mt-6 md:mt-8 text-white font-semibold text-lg uppercase tracking-wide">{s.title}</div>
              <p className="mt-3 text-[#f2f2f2] text-[14px] leading-relaxed">{s.desc}</p>
            </SafeMotion>
          ))}
        </div>
      </div>
    </section>
  );
}
